import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
//import { BottomNavigationMobile } from "../../navigationSection/BottomNavigationMobile";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";

//import HomeReusableTopBarNavigation from "../../../superAdminComponents/superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { get_category_menu_setup } from "../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { logOutUser } from "../../../../store/actions/authAction";
import OrderRequestBodySubstitute from "./OrderRequestBodySubstitute";
import { useDispatch } from "react-redux";
import { CLEAR_CART_DATA, FILTERED_MENU_ORDER } from "../../../../store/types";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

const OrderRequest = (props) => {
  const [state, setState] = useState({ selectedPage: 1, status: "All" });

  const dispatch = useDispatch();
  // const onPageChange = (value) => (e) => {
  //   setState({ ...state, selectedPage: value });
  // };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.get_category_menu_setup(token);
  }, []);

  useEffect(() => {
    dispatch({ type: CLEAR_CART_DATA });
  }, []);
  useEffect(() => {
    let filteredMenuData = [];
    let existingUserData = JSON.parse(JSON.stringify(props.orderData));
    let orderSelected = existingUserData.orderSelected;
    for (let i = 0; i < props.menuCategory.length; i++) {
      let tempCategory = JSON.parse(JSON.stringify(props.menuCategory[i]));
      tempCategory.items = [];

      //tempCategory.items.filteredItems = [];

      for (let j = 0; j < props.menuCategory[i].items.length; j++) {
        if (
          props.menuCategory?.[i].items?.[j]?.[orderSelected]?.value &&
          props.menuCategory?.[i].items?.[j].status
        ) {
          let dataToSend = JSON.parse(
            JSON.stringify(props.menuCategory[i].items[j])
          );

          dataToSend[orderSelected].sizes = [];
          dataToSend.cartLength = 0;

          for (
            let m = 0;
            m < props.menuCategory[i].items[j][orderSelected].sizes.length;
            m++
          ) {
            if (
              props.menuCategory[i].items[j][orderSelected].sizes[m].available
            ) {
              dataToSend[orderSelected].sizes.push(
                props.menuCategory[i].items[j][orderSelected].sizes[m]
              );
            }
          }

          tempCategory.items.push(dataToSend);
        }
      }
      if (tempCategory.items.length > 0) {
        filteredMenuData.push(tempCategory);
      }
      tempCategory = {};
    }

    dispatch({ type: FILTERED_MENU_ORDER, payload: filteredMenuData });
  }, [props.menuCategory]);
  const [menuData, setMenuData] = useState([]);

  useEffect(() => {
    setMenuData(props.vendor_filtered_menu);
  }, [props.vendor_filtered_menu]);

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <Container fluid className="vendor-orders-request">
            <Row>
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
              <div className="top-panel">
                <TopNavigationBarMobile displayLeft="logo" />
              </div>
              <div className="right-side-panel">
                <RightSideNavigation />
                <OrderRequestBodySubstitute
                  selectedTabId={
                    props && props.orderData && props.orderData.selectedTabId
                  }
                  data={menuData}
                  orderSelected={
                    props && props.orderData && props.orderData.orderSelected
                  }
                />
                <br />
              </div>
              <div className="bottom-panel"></div>
            </Row>
          </Container>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

OrderRequest.propTypes = {
  logOutUser: PropTypes.func.isRequired,
  get_category_menu_setup: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  menuCategory: state.onboarding.menuCategory,
  vendor_filtered_menu: state.vendorOrdering.vendor_filtered_menu,
  orderData: state.vendorOrdering.vendor_order_data,
});

export default connect(mapStateToProps, {
  logOutUser,
  get_category_menu_setup,
})(withRouter(OrderRequest));
